<template>
  <div>
    <!-- 侵权识别详情 -->
    <el-dialog title="侵权识别对比" :visible.sync="dialogVisible" width="1200px"
      :close-on-click-modal="false" center>
      <div class="tort-detect">
        <!-- 结论状态 -->
        <el-tag class="conclusion-tag" size="mini" type="warning" v-if="detail.consensus">
          {{ detail.consensus == 'diverge' ? '结论分歧' : '结论一致' }}
        </el-tag>

        <!-- 待检测商品图 -->
        <div class="goods">
          <p class="module-label">待检测商品图</p>
          <el-image :src="detail.image_url" :preview-src-list="[detail.image_url]" fit="cover">
            <div slot="error" class="image-error">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>

        <!-- 综合判定 -->
        <div class="summary" v-if="detail.comparison_summary || detail.fingerprint_summary">
          <i class="el-icon-warning"></i>
          <div>
            <p v-if="detail.comparison_summary">{{ detail.comparison_summary }}</p>
            <p v-if="detail.fingerprint_summary">{{ detail.fingerprint_summary }}</p>
          </div>
        </div>

        <!-- 下方双路对比 -->
        <div class="route-list">
          <!-- Qwen 视觉细判 -->
          <div class="route-card">
            <div class="route-title">
              <div>
                <i class="el-icon-full-screen"></i>
                <span>Qwen 视觉细判</span>
                <el-tag size="mini" :type="getRiskType(detail.vision_risk_level)"
                  v-if="detail.vision_risk_label">
                  {{ detail.vision_risk_label }}
                </el-tag>
              </div>
            </div>
            <div class="route-content">
              <p v-if="detail.vision_summary">{{ detail.vision_summary }}</p>
              <p class="minor" v-if="detail.vision_brands && detail.vision_brands.length">
                疑似品牌：{{ detail.vision_brands.join('、') }}
              </p>
              <p v-if="detail.vision_details">{{ detail.vision_details }}</p>
              <p v-if="detail.vision_suggestion">建议：{{ detail.vision_suggestion }}</p>
            </div>
          </div>

          <!-- MCP 指纹库 -->
          <div class="route-card">
            <div class="route-title">
              <div>
                <i class="el-icon-warning-outline"></i>
                <span>MCP 指纹库</span>
                <el-tag size="mini" :type="getRiskType(detail.fingerprint_risk_level)"
                  v-if="detail.fingerprint_risk_label">
                  {{ detail.fingerprint_risk_label }}
                </el-tag>
              </div>
            </div>
            <div class="route-content">
              <p v-if="detail.fingerprint_summary">{{ detail.fingerprint_summary }}</p>
              <p class="minor" v-if="detail.fingerprint_max_similarity">
                最高相似度：<b>{{ detail.fingerprint_max_similarity }}</b>
              </p>

              <!-- fingerprint_cases 每条案例单独显示 -->
              <div class="fingerprint-cases" v-if="detail.fingerprint_cases && detail.fingerprint_cases.length">
                <p class="cases-title">相似侵权案例</p>
                <div class="case-item" v-for="(caseItem, caseIndex) in detail.fingerprint_cases" :key="caseIndex">
                  <el-image :src="caseItem.pic_url" :preview-src-list="[caseItem.pic_url]" fit="cover"></el-image>
                  <div class="case-detail">
                    <p>
                      <el-tag size="mini">相似度 {{ caseItem.similarity }}</el-tag>
                      <span v-if="caseItem.goods_id">goods_id={{ caseItem.goods_id }}</span>
                    </p>
                    <p class="case-title" v-if="caseItem.title">{{ caseItem.title }}</p>
                    <p class="minor" v-if="caseItem.operate_remark">
                      关联备注：{{ caseItem.operate_remark }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p class="detected-at" v-if="detail.detected_at">检测时间：{{ detail.detected_at }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      detail: {},
    };
  },
  methods: {
    // 打开弹框并读取当前商品的侵权识别结果
    openDialog(item) {
      this.detail = item.tort_detect
      this.dialogVisible = true
    },
    // 风险等级对应标签颜色
    getRiskType(riskLevel) {
      if (riskLevel == 'high') return 'danger'
      if (riskLevel == 'low') return 'success'
      return 'warning'
    },
  },
};
</script>

<style lang='scss' scoped>
.tort-detect {
  position: relative;
  max-height: 650px;
  overflow-y: auto;
  padding: 0 4px;
  color: #303133;

  .conclusion-tag {
    position: absolute;
    top: 0;
    left: 130px;
  }

  .module-label {
    margin-bottom: 8px;
    color: #909399;
  }

  .goods {
    margin-bottom: 14px;

    /deep/ .el-image {
      width: 160px;
      height: 160px;
      border: 1px solid #ebeef5;
      border-radius: 8px;
    }
  }

  .image-error {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: #f5f7fa;
    color: #c0c4cc;
    font-size: 30px;
  }

  .summary {
    display: flex;
    margin-bottom: 14px;
    padding: 18px 24px;
    border: 1px solid #f3e1a7;
    border-radius: 8px;
    background-color: #fdf9e9;
    line-height: 26px;

    >i {
      margin: 3px 14px 0 0;
      color: #e6a23c;
      font-size: 24px;
    }
  }

  .route-list {
    display: flex;
    align-items: flex-start;
  
  }

  .route-card {
    box-sizing: border-box;
    width: calc(50% - 14px);
    margin: 0 7px;
    padding: 14px;
    border: 1px solid #ebeef5;
    border-radius: 8px;

    .route-title {
      padding-bottom: 12px;
      border-bottom: 1px dashed #ebeef5;
      font-size: 15px;
      font-weight: 600;

      i {
        margin-right: 6px;
      }

      .el-tag {
        margin-left: 8px;
      }
    }

    .route-content {
      line-height: 24px;

      >p {
        margin-top: 10px;
        word-break: break-all;
      }
    }

    .minor {
      color: #909399;
      font-size: 12px;
    }
  }

  .fingerprint-cases {
    margin-top: 12px;
    border-top: 1px dashed #ebeef5;

    .cases-title {
      padding: 10px 0 4px;
      color: #909399;
      font-size: 12px;
    }

    .case-item {
      display: flex;
      padding: 10px 0;
      border-top: 1px dashed #ebeef5;

      /deep/ .el-image {
        flex: 0 0 78px;
        width: 78px;
        height: 78px;
        margin-right: 12px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
      }
    }

    .case-detail {
      flex: 1;
      min-width: 0;
      word-break: break-all;

      .el-tag {
        margin-right: 8px;
      }

      .case-title {
        margin-top: 6px;
      }
    }
  }

  .detected-at {
    margin-top: 12px;
    text-align: right;
    color: #909399;
    font-size: 12px;
  }
}
</style>
